import { Table, TableCell, TablePager, TableRow } from '@fukuri-admins/ui/common';
import { CheckIcon } from '@fukuri-admins/ui/common/Icons';
import { getAnswerLabels } from '../constants';
import styles from './styles.module.scss';

type Answer = {
  answer_value: number;
  stress_assessment_question: {
    id: number;
    body: string;
    left_label: string;
  };
};

type AnswersByCategory = Record<string, Answer[]>;

type Props = {
  answersByCategory: AnswersByCategory;
  categoryTitleMap: Record<string, string>;
  totalCount: number;
  itemCount: number;
};

export const StressAssessmentAnswerTablePresentation: React.FC<Props> = ({
  answersByCategory,
  categoryTitleMap,
  totalCount,
  itemCount,
}) => {
  const renderAnswerCell = (answerValue: number, targetValue: number) => {
    return answerValue === targetValue ? (
      <CheckIcon size='sm' className={styles.checkIcon} />
    ) : null;
  };

  return (
    <div className={styles.container}>
      <div className={styles.tablesWrapper}>
        {Object.entries(answersByCategory).map(([category, categoryAnswers]) => {
          const leftLabel = categoryAnswers[0]?.stress_assessment_question.left_label;
          const headerLabels = getAnswerLabels(leftLabel);

          return (
            <div key={category} className={styles.categorySection}>
              <h3 className={styles.categoryTitle}>{categoryTitleMap[category] || category}</h3>
              <Table
                scrollable
                headers={[
                  { label: 'No', className: styles.colNo },
                  { label: '設問', className: styles.colQuestion },
                  { label: headerLabels[0], className: styles.colAnswer },
                  { label: headerLabels[1], className: styles.colAnswer },
                  { label: headerLabels[2], className: styles.colAnswer },
                  { label: headerLabels[3], className: styles.colAnswer },
                ]}
              >
                {categoryAnswers.map((answer, index) => (
                  <TableRow key={index}>
                    <TableCell align='center'>{answer.stress_assessment_question.id}</TableCell>
                    <TableCell>{answer.stress_assessment_question.body}</TableCell>
                    <TableCell align='center'>{renderAnswerCell(answer.answer_value, 1)}</TableCell>
                    <TableCell align='center'>{renderAnswerCell(answer.answer_value, 2)}</TableCell>
                    <TableCell align='center'>{renderAnswerCell(answer.answer_value, 3)}</TableCell>
                    <TableCell align='center'>{renderAnswerCell(answer.answer_value, 4)}</TableCell>
                  </TableRow>
                ))}
              </Table>
            </div>
          );
        })}
      </div>
      <TablePager
        currentPage={1}
        totalPage={1}
        totalCount={totalCount}
        itemCount={itemCount}
        onPageChange={() => {}}
      />
    </div>
  );
};
